<template>
  <transition name="fade">
    <div v-if="isVisible" :class="['toast', `toast--${type}`]" @click="dismiss">
      <div class="toast__content">
        <span>{{ message }}</span>
      </div>
      <button class="toast__close" @click.stop="dismiss">&times;</button>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['success', 'error', 'info', 'warning'].includes(value)
  },
  duration: {
    type: Number,
    default: 5000
  },
  onDismiss: {
    type: Function,
    default: () => {}
  }
});

const isVisible = ref(false);
let timeoutId = null;

const dismiss = () => {
  isVisible.value = false;
  clearTimeout(timeoutId);
  setTimeout(() => props.onDismiss(), 300); // Wait for fade out animation
};

const show = () => {
  isVisible.value = true;
  if (props.duration > 0) {
    timeoutId = setTimeout(dismiss, props.duration);
  }
};

onMounted(() => {
  show();
});

defineExpose({
  dismiss
});
</script>

<style scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 4px;
  color: white;
  margin-bottom: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 350px;
  pointer-events: auto;
  transition: opacity 0.3s ease;
}

.toast--success {
  background-color: #10b981;
}

.toast--error {
  background-color: #ef4444;
}

.toast--info {
  background-color: #3b82f6;
}

.toast--warning {
  background-color: #f59e0b;
}

.toast__content {
  flex: 1;
  margin-right: 12px;
}

.toast__close {
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.toast__close:hover {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
